import { useEffect, useState } from "react";
import {
  FALLBACK_STORE_IMAGE,
  getStoreImageUrl,
  getStoreLogoUrl,
  getStorePhotoUrl,
} from "../utils/storeImage";

type Props = {
  placeId?: string;
  storeWebsite?: string;
  title: string;
};

type Stage = "photo" | "logo" | "fallback";

const stageFor = (photoUrl: string | null, preferredUrl: string): Stage => {
  if (photoUrl) return "photo";
  if (preferredUrl === FALLBACK_STORE_IMAGE) return "fallback";
  return "logo";
};

export default function StoreCardImage({
  placeId,
  storeWebsite = "",
  title,
}: Props) {
  const photoUrl = getStorePhotoUrl(placeId);
  const preferredUrl = getStoreImageUrl(placeId, storeWebsite);
  const [src, setSrc] = useState(preferredUrl);
  const [stage, setStage] = useState<Stage>(stageFor(photoUrl, preferredUrl));

  useEffect(() => {
    setSrc(preferredUrl);
    setStage(stageFor(photoUrl, preferredUrl));
  }, [preferredUrl, photoUrl]);

  const showNext = () => {
    if (stage === "fallback") return;
    const logoUrl = getStoreLogoUrl(storeWebsite);
    if (stage === "photo" && logoUrl !== FALLBACK_STORE_IMAGE) {
      setStage("logo");
      setSrc(logoUrl);
      return;
    }
    setStage("fallback");
    setSrc(FALLBACK_STORE_IMAGE);
  };

  return (
    <img
      src={src}
      alt={title}
      loading="lazy"
      draggable={false}
      onDragStart={(event) => event.preventDefault()}
      className={`w-full h-full brightness-[95%] contrast-100 saturate-[120%] select-none [-webkit-user-drag:none] ${
        stage === "photo" ? "object-cover" : "object-contain"
      }`}
      onError={showNext}
    />
  );
}
